
import { HTMLAttributes } from "react";

interface SvgLogoProps extends HTMLAttributes<SVGElement> {
  size?: "small" | "medium" | "large";
}

export function SvgLogo({ className = "", size = "medium", ...props }: SvgLogoProps) {
  // Define sizes for different variants
  const logoSizes = {
    small: "h-10 w-auto",
    medium: "h-14 w-auto", 
    large: "h-20 w-auto"
  };
  
  return (
    <svg 
      viewBox="0 0 400 120" 
      xmlns="http://www.w3.org/2000/svg"
      className={`${logoSizes[size]} ${className}`}
      {...props}
    >
      {/* Clock Circle Background */}
      <circle cx="60" cy="60" r="45" fill="none" stroke="#1e40af" strokeWidth="6"/>
      
      {/* Clock Face */}
      <circle cx="60" cy="60" r="35" fill="#ffffff" stroke="#e5e7eb" strokeWidth="1"/>
      
      {/* Hour Markers */}
      <g stroke="#6b7280" strokeWidth="2">
        {/* 12 o'clock */}
        <line x1="60" y1="30" x2="60" y2="35"/>
        {/* 3 o'clock */}
        <line x1="90" y1="60" x2="85" y2="60"/>
        {/* 6 o'clock */}
        <line x1="60" y1="90" x2="60" y2="85"/>
        {/* 9 o'clock */}
        <line x1="30" y1="60" x2="35" y2="60"/>
      </g>
      
      {/* Clock Hands */}
      {/* Hour Hand */}
      <line x1="60" y1="60" x2="60" y2="45" stroke="#1e40af" strokeWidth="4" strokeLinecap="round"/>
      {/* Minute Hand */}
      <line x1="60" y1="60" x2="75" y2="40" stroke="#f59e0b" strokeWidth="3" strokeLinecap="round"/>
      
      {/* Center Dot */}
      <circle cx="60" cy="60" r="3" fill="#1e40af"/>
      
      {/* Progress Arc */}
      <path d="M 60 15 A 45 45 0 0 1 90 30" fill="none" stroke="#10b981" strokeWidth="6" strokeLinecap="round"/>
      
      {/* Text */}
      <text x="130" y="45" fontFamily="Arial, sans-serif" fontSize="36" fontWeight="bold" fill="#1f2937">HOUR</text>
      <text x="130" y="80" fontFamily="Arial, sans-serif" fontSize="36" fontWeight="bold" fill="#1f2937">TRACKER</text>
      
      {/* Accent Elements */}
      <circle cx="350" cy="25" r="8" fill="#10b981" opacity="0.3"/>
      <circle cx="370" cy="35" r="5" fill="#f59e0b" opacity="0.4"/>
      <circle cx="360" cy="50" r="6" fill="#1e40af" opacity="0.3"/>
    </svg>
  );
}
